define('mypages/accountlimitations/depositLimitation',['jquery', 'module', 'mypages/accountlimitations/depositLimitPopup'], function ($, module, depositLimitPopup) {
	'use strict';

	$(function () {
		var jsonString = module.config().formBean;
		if (jsonString !== '') {
			jsonString = $.parseJSON(module.config().formBean);
			var $depositLimits = $('#deposit-limits');
			initAllLimitProgressMeters(jsonString, $depositLimits);
			initAllPendingLimit(jsonString, $depositLimits);
			setupAddButtons(jsonString);
			setupEditButtons(jsonString);
		}
	});

	function initAllLimitProgressMeters(jsonString, $depositLimits) {

		var allDepositLimitTypeRow = $depositLimits.find('.depositLimitRowType');
		var dailyMap = {limit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_DAILY_LIMIT, percentage: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_DAILY_PERCENTAGE,
			limitLeft: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_DAILY_LIMIT_LEFT};
		var weeklyMap = {limit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_WEEKLY_LIMIT, percentage: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_WEEKLY_PERCENTAGE,
			limitLeft: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_WEEKLY_LIMIT_LEFT};
		var monthlyMap = {limit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_MONTHLY_LIMIT, percentage: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_MONTHLY_PERCENTAGE,
			limitLeft: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_MONTHLY_LIMIT_LEFT};
		var jsonValueMaps = [dailyMap, weeklyMap, monthlyMap];

		allDepositLimitTypeRow.each(function(index){
			initLimitProgressMeter($(this), jsonValueMaps[index], jsonString);
		});
	}

	function initLimitProgressMeter($depositTypeRow, jsonValueMap, jsonString) {

		var $progressBar = $depositTypeRow.find('.progress-bar');
		var $yesLimitListItem = $depositTypeRow.find('.yes-limit');
		var $noLimit = $depositTypeRow.find('.no-limit');
		var $addOrEditBtn = $depositTypeRow.find('.responsible-btn').find('.ui-button');
		var paramResponsibleGamingDepositTypeLimit = 0;
		var paramResponsibleGamingDepositTypeSpent = 0;

		if(jsonValueMap.limit !== undefined && jsonValueMap.percentage !== undefined){
			paramResponsibleGamingDepositTypeLimit = jsonValueMap.limit;

			var percentageFloat = Number(jsonValueMap.percentage);
            var percentageReachedFlag = percentageFloat >= 100;
			if(percentageReachedFlag){
				percentageFloat = 100;
			}
			var percentageReachedPx =  new String(percentageFloat) + "px";

			var $meter = $progressBar.find('.meter');
			$meter.width(percentageReachedPx);

			$progressBar.show();
			if (percentageReachedFlag) {
				$depositTypeRow.find('li.percentage-reached').show();
				$depositTypeRow.find('li.percentage-not-reached').hide();
			} else {
				$depositTypeRow.find('li.percentage-reached').hide();
				$depositTypeRow.find('li.percentage-not-reached').show();
				var limitLeft = jsonValueMap.limitLeft;
				var textLimitLeft = jsonString.ACCOUNT_LIMITATION_LIMIT_LEFT;
				$depositTypeRow.find('li.percentage-not-reached').find('p').text(limitLeft + textLimitLeft);
			}
			var $yesLimit = $yesLimitListItem.find('p');
			$yesLimit.text(paramResponsibleGamingDepositTypeLimit);
			$noLimit.hide();
			$addOrEditBtn.eq(0).show();
			$addOrEditBtn.eq(1).hide();

		} else {
			$depositTypeRow.find('li.percentage-reached').hide();
			$depositTypeRow.find('li.percentage-not-reached').hide();
			$noLimit.show();
			$yesLimitListItem.hide();
			$progressBar.hide();
			$addOrEditBtn.eq(0).hide();
			$addOrEditBtn.eq(1).show();
		}
	}



	function initAllPendingLimit(jsonString, $depositLimits) {

		var allDepositPendingLimitTypeRow = $depositLimits.find('.depositPendingLimitRowType');

		var jsonDailyMap = {pendingLimit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_DAILY_LIMIT, remove: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_REMOVE_DAILY_LIMIT,
			pendingLeft : jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_DAILY_LEFT};
		var jsonWeeklyMap = {pendingLimit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_WEEKLY_LIMIT, remove: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_REMOVE_WEEKLY_LIMIT,
			pendingLeft : jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_WEEKLY_LEFT};
		var jsonMonthlyMap = {pendingLimit: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_MONTHLY_LIMIT, remove: jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_REMOVE_MONTHLY_LIMIT,
			pendingLeft : jsonString.PARAM_RESPONSIBLE_GAMING_DEPOSIT_PENDING_MONTHLY_LEFT};

		var jsonValueMaps = [jsonDailyMap, jsonWeeklyMap, jsonMonthlyMap];

		allDepositPendingLimitTypeRow.each(function(index){
			initPendingLimit($(this), jsonValueMaps[index], jsonString);
		});
	}

	function initPendingLimit($depositPendingTypeRow, jsonValueMap, jsonString) {
		var paramResponsibleGamingDepositPendingLimit = jsonValueMap.pendingLimit;
		var paramResponsibleGamingDepositRemoveLimit = jsonValueMap.remove;
		var paramResponsibleGamingPendingLeft = jsonValueMap.pendingLeft;

		if(paramResponsibleGamingDepositRemoveLimit !== undefined || paramResponsibleGamingDepositPendingLimit !== undefined){

			var $changeToBeMadeField = $depositPendingTypeRow.find('.remove-limit');
			if(paramResponsibleGamingDepositRemoveLimit !== undefined){
				// Show text that explains that the limit will be removed
				$changeToBeMadeField.text(jsonString.RESPONSIBLE_GAMING_REMOVE_LIMIT);
			} else{
				// Else show the pending value
				$changeToBeMadeField.text(paramResponsibleGamingDepositPendingLimit);
			}

			// Show time left until the pending value is used
			var $timeUntilPendingValueIsUsedParagraph = $depositPendingTypeRow.find('.account-limitations p');
			$timeUntilPendingValueIsUsedParagraph.text(paramResponsibleGamingPendingLeft);

			// Initialize the cancel pending action button
			var $cancelPendingActionButton = $depositPendingTypeRow.find('.ui-button');
			$cancelPendingActionButton.off().on('click', function(){
				var limitType = $($cancelPendingActionButton.parent().parent()).attr('id').replace('pending-', '');
				$.post('/pp?flow=ResponsibleGamingDepositLimitCancelPending', {limitType: limitType}, function (response) {
					depositLimitPopup.handleDepositLimitChangeResponse(response);
				});
				return false;
			});

			$depositPendingTypeRow.show();
		}
	}



	function setupAddButtons(jsonString){
		$('.responsible-btn').find('.addbutton').each(function(index, value){
			var $button = $(value);
			$button.off().on('click', function(event){
				var $element = $button;
				setupSingleEditButton($element, jsonString);
				return false;
			});
		});
	}

	function setupEditButtons(jsonString){
		$('.responsible-btn').find('.editbutton').each(function(index, value){
			var $button = $(value);
			$button.off().on('click', function(event){
				var $element = $button;
				setupSingleEditButton($element, jsonString);
				return false;
			});
		});
	}

	function setupSingleEditButton($element, jsonString) {
		depositLimitPopup.onShowDepositLimitPopUp($element, jsonString);
	}

	/*
	** Code if there should be a confirmation popup before adding a limit
	function setupSingleAddButton($element, jsonString) {
		var $confirmationDepositLimit = $('#confirmation-deposit-limit');
		var header = jsonString.DEPOSIT_LIMIT_CONFIRM_HEADER_ADD_OR_EDIT;
		window.top.showModalPanel(header, $confirmationDepositLimit.html(), null, null, null, true, true);
		setupButtonClickHandlers($element, jsonString);
	}


	function setupButtonClickHandlers($element, jsonString){
		var $modalPanel = $('#modalPanel', parent.document);

		var depositLimitPopupButton = $modalPanel.find('.depositLimitPopupButton');
		depositLimitPopupButton.off().on('click', function(eventevent){
			parent.modalPanel.hide();
			depositLimitPopup.onShowDepositLimitPopUp($element, jsonString);
			return false;
		});

		var depositLimitPopupCancel = $modalPanel.find('.depositLimitPopupCancel');
		depositLimitPopupCancel.off().on('click', depositLimitPopup.onCancelConfirmationDepositLimit);

	}
	 */
});

